































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import EventBus from '@/plugins/EventBus'

interface ImportRow {
  linha: number
  subEspecialidade: string
  codigoProcedimento: string
  subEspecialidadeId: any
  erro: string
}

interface ResultRow {
  codigoProcedimento: string
  success: boolean
  message: string
}

@Component
export default class ComponentModalImportarProcedimentos extends Vue {
  @Prop({ required: true }) especialidadeId: any

  $refs!: { fileInput: HTMLInputElement }

  rawInput: string = ''
  nomeArquivo: string = ''
  importRows: ImportRow[] = []
  resultadoImport: ResultRow[] = []
  loadingImport: boolean = false
  separador: string = '\t'

  get store() { return getModule(FinanceiroStore, this.$store) }

  get modalAberto() { return this.store.modal.importarProcedimentos }
  set modalAberto(value: boolean) { this.store.setModal({ name: 'importarProcedimentos', value }) }

  get separadorLabel() {
    if (this.separador === '\t') return 'Tabulação (Excel)'
    if (this.separador === ';') return 'Ponto e vírgula (;)'
    return 'Vírgula (,)'
  }

  get rowsValidas() { return this.importRows.filter(r => !r.erro) }
  get rowsComErro() { return this.importRows.filter(r => !!r.erro) }

  get headersPreview() {
    return [
      { text: 'Linha', value: 'linha', align: 'center', sortable: false },
      { text: 'Subespecialidade', value: 'subEspecialidade', align: 'left', sortable: false },
      { text: 'Código do Procedimento', value: 'codigoProcedimento', align: 'left', sortable: false },
      { text: 'Status', value: 'erro', align: 'left', sortable: false },
    ]
  }

  get headersResultado() {
    return [
      { text: 'Código do Procedimento', value: 'codigoProcedimento', align: 'left', sortable: false },
      { text: 'Resultado', value: 'success', align: 'left', sortable: false },
    ]
  }

  detectSeparator(line: string): string {
    if (line.includes('\t')) return '\t'
    if (line.includes(';')) return ';'
    return ','
  }

  parseInput() {
    const text = this.rawInput
    if (!text || !text.trim()) { this.importRows = []; return }

    const lines = text.split('\n').map(l => l.replace(/\r$/, '')).filter(l => l.trim())
    if (!lines.length) { this.importRows = []; return }

    this.separador = this.detectSeparator(lines[0])

    const firstLower = lines[0].toLowerCase()
    const isHeader = firstLower.includes('subespec') || firstLower.includes('procedimento') ||
                     firstLower.includes('código') || firstLower.includes('codigo')
    const dataLines = isHeader ? lines.slice(1) : lines

    const subEsps = this.store.itemsSubEspecialidade

    this.importRows = dataLines
      .map((line, idx) => {
        const parts = line.split(this.separador).map(p => p.trim().replace(/^["']|["']$/g, ''))

        let subEspDesc = ''
        let codigoProcedimento = ''

        if (parts.length >= 2) {
          subEspDesc = parts[0]
          codigoProcedimento = parts[1]
        } else {
          codigoProcedimento = parts[0]
        }

        let subEspecialidadeId: any = null
        let erro = ''

        if (subEspDesc) {
          const match = subEsps.find((s: any) => {
            if (!s.descricao) return false
            return s.descricao.toLowerCase().trim() === subEspDesc.toLowerCase().trim()
          })
          if (match) subEspecialidadeId = match.id
          else erro = `Subespecialidade "${subEspDesc}" não encontrada`
        }

        if (!codigoProcedimento) {
          erro = 'Código do procedimento obrigatório'
        }

        return {
          linha: idx + (isHeader ? 2 : 1),
          subEspecialidade: subEspDesc,
          codigoProcedimento,
          subEspecialidadeId,
          erro,
        } as ImportRow
      })
      .filter(r => r.codigoProcedimento || r.subEspecialidade)
  }

  async confirmarImport() {
    const validas = this.rowsValidas
    if (!validas.length) return

    this.loadingImport = true
    const resultados: ResultRow[] = []

    for (const row of validas) {
      const res = await this.store.createEspecialidadeProcedimentoDireto({
        especialidadeId: this.especialidadeId,
        subEspecialidadeId: row.subEspecialidadeId || null,
        codigoProcedimento: row.codigoProcedimento,
      })
      
      const isSuccess = res.success !== undefined && res.success !== null ? res.success : false

      resultados.push({
        codigoProcedimento: row.codigoProcedimento,
        success: isSuccess,
        message: isSuccess ? '' : (res.message || 'Erro'),
      })
    }

    this.resultadoImport = resultados
    const sucessos = resultados.filter(r => r.success).length
    const falhas = resultados.filter(r => !r.success).length

    let snackbarText = `${sucessos} procedimento(s) importado(s) com sucesso!`
    if (falhas > 0) {
      snackbarText = `Importação concluída: ${sucessos} criado(s), ${falhas} com erro`
    }

    EventBus.$emit('setSnackbar', {
      show: true,
      text: snackbarText,
      icon: falhas > 0 ? 'warning' : 'done',
      color: falhas > 0 ? '#F57F17' : '#2E7D32',
    })

    if (sucessos > 0) this.$emit('update-items-table')
    this.loadingImport = false
  }

  downloadTemplate() {
    const bom = '\uFEFF'
    const csv = bom + 'Subespecialidade;Codigo do Procedimento\n;'
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = 'template-procedimentos.csv'
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    URL.revokeObjectURL(url)
  }

  onFileChange(event: Event) {
    const file = ((event.target as HTMLInputElement).files || [])[0]
    if (!file) return
    this.nomeArquivo = file.name
    const reader = new FileReader()
    reader.onload = (e: any) => {
      this.rawInput = (e.target.result as string).replace(/^\uFEFF/, '')
      this.parseInput()
    }
    reader.readAsText(file, 'UTF-8')
    ;(event.target as HTMLInputElement).value = ''
  }

  fechar() {
    if (this.loadingImport) return
    this.rawInput = ''
    this.nomeArquivo = ''
    this.importRows = []
    this.resultadoImport = []
    this.modalAberto = false
  }

  @Watch('modalAberto')
  onOpen(value: boolean) {
    if (!value) this.fechar()
  }
}
